export const DEFAULT_DISTANCE_KM = 20;
